import { createSelector } from 'reselect';

import { SECTIONS_HEIGHTS } from '@shopDetails/model';
import getPropFromModule from './getPropFromModule';

const getSectionsHeights = createSelector(
  state => getPropFromModule(state, SECTIONS_HEIGHTS),
  heights => heights.toJS(),
);

export default getSectionsHeights;
